import { AuthenticatedRoute } from '@rhino-project/ui-heroui';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context: { rhino }, location }) => {
    if (!rhino.user) {
      // Send unauthenticated visitors to the ported Harborlight login screen
      // (not the framework-branded auth page).
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href
        }
      });
    }
  },
  component: AuthenticatedRoute
});
